import { render } from "./BoardUpdateModal.vue?vue&type=template&id=2f4cca24&scoped=true"
import script from "./BoardUpdateModal.vue?vue&type=script&lang=js"
export * from "./BoardUpdateModal.vue?vue&type=script&lang=js"

import "./BoardUpdateModal.vue?vue&type=style&index=0&id=2f4cca24&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f4cca24"

export default script